import React, { useRef } from "react";
import PropTypes from "prop-types";
import CardBadge from "../../component-library/CardBadge/CardBadge";
import CardStatus from "../../component-library/CardMeta/CardStatus";
import CardWrapper from "../../component-library/CardWrapper";
import CardLongContent from "./CardLongContent";
import CardLongImageContainer from "./CardLongImageContainer";
import CardLongText from "./CardLongText";
import CardLongFooter from "./CardLongFooter";
import useHideElementsIfNoHasSupport from "../../hooks/useHideElementsIfNoHasSupport";

const CardLong = ({
  id = 1,
  layoutVariation = "default",
  children,
  cardClassName = "",
  imageSrc = "",
  title = "",
  text = "",
  footerContent = ""
}) => {
  const containerRef = useRef(null);

  // Hide elements when :has is not supported
  useHideElementsIfNoHasSupport();

  // Scroll to top when the card is not in view
  const scrollToTop = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      if (rect.top < 0) {
        containerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <CardWrapper
      cardType="long"
      layoutVariation={layoutVariation}
      id={`CardLong-${id}`}
      className={cardClassName}
      ref={containerRef}
    >
      {React.Children.map(children, (child) => {
        if (child && child.type && child.type === CardLongContent) {
          return React.cloneElement(child, { scrollToTop });
        }
        return child;
      })}
    </CardWrapper>
  );
};
CardLong.propTypes = {
  layoutVariation: PropTypes.string,
  imageSrc: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  footerContent: PropTypes.node
};

export default Object.assign(CardLong, {
  Status: CardStatus,
  Content: CardLongContent,
  Footer: CardLongFooter,
  Text: CardLongText,
  Svg: CardLongImageContainer,
  Badge: CardBadge
});
